<template>
  <div class="push-configuration">
    <div class="push-configuration-container-top">
      <el-button
        v-show="currentComponent === 'display'"
        type="primary"
        plain
        size="small"
        class="push-configuration-container-top-edit"
        @click="onEditClick"
      >
        编辑
      </el-button>
    </div>
    <div class="push-configuration-container">
      <div class="push-configuration-container-bottom">
        <div class="push-info-edit">
          <div class="info-section">
            <div class="section-header">
              <span class="section-title">推送医院消息</span>
            </div>
            <div class="info-content">
              <div class="push-info-item">
                <div class="item-label">推送对象配置：</div>
                <div class="form-input" v-show="currentComponent === 'edit'">
                  <el-select
                    v-model="editModel.chatRooms"
                    filterable
                    placeholder="请选择微信群"
                  >
                    <el-option
                      v-for="(item, index) in chatRoomsList"
                      :key="index"
                      :label="item.nickName"
                      :value="item.userName"
                    >
                    </el-option>
                    <el-option
                      v-if="
                        chatRoomsList.length === 0 && editModel.chatRooms !== ''
                      "
                      :key="editModel.chatRooms"
                      :label="settingInfoModel.chatRoomsName"
                      :value="editModel.chatRooms"
                    ></el-option>
                  </el-select>
                </div>
                <div class="item-value" v-show="currentComponent === 'display'">
                  {{ settingInfoModel.chatRoomsName || "-" }}
                </div>
                <!-- 刷新图标按钮 -->
                <i
                  v-show="currentComponent === 'edit'"
                  class="el-icon-refresh refresh-icon"
                  @click="onRefreshClick"
                ></i>
              </div>

              <div class="push-info-item" style="align-items: flex-start">
                <div class="item-label">推送类型：</div>
                <div class="form-input">
                  <!-- <div class="info-item-card">
                    <div class="push-info-item">
                      <div class="switch-item">
                        <span>监测设备开启成功</span>
                        <el-switch
                          v-model="editModel.startMonitorSuccess"
                        ></el-switch>
                      </div>
                    </div>
                    <div class="push-time">推送时间：识别满足即触发</div>
                    <div class="push-content">
                      推送内容：您的睡眠设备启动成功并开启监测，请安心开始睡眠监测。
                    </div>
                  </div> -->
                  <div class="info-item-card">
                    <div class="push-info-item">
                      <div class="switch-item">
                        <span class="switch-item-label">推送报告</span>
                        <el-switch
                          v-if="currentComponent === 'edit'"
                          v-model="editModel.reportSendType"
                        ></el-switch>
                        <el-switch
                          v-if="currentComponent === 'display'"
                          :value="settingInfoModel.reportSendType === 1"
                        ></el-switch>
                      </div>
                    </div>
                    <div class="push-time">
                      推送时间：仅完整报告第一次生成时推送
                    </div>
                    <div class="push-content">推送内容：pdf报告文件</div>
                    <div class="push-text">
                      <div>推送文案：</div>
                      <div
                        class="form-input"
                        v-show="currentComponent === 'edit'"
                      >
                        <el-input
                          v-model="editModel.reportCopywriter"
                          placeholder="请输入"
                        ></el-input>
                      </div>
                      <div
                        class="item-value"
                        v-show="currentComponent === 'display'"
                      >
                        {{ settingInfoModel.reportCopywriter || "-" }}
                      </div>
                    </div>
                  </div>
                  <div class="info-item-card">
                    <div class="push-info-item">
                      <div class="switch-item">
                        <span class="switch-item-label">推送重启提示</span>
                        <el-switch
                          v-if="currentComponent === 'edit'"
                          v-model="editModel.restartReminder"
                        ></el-switch>
                        <el-switch
                          v-if="currentComponent === 'display'"
                          :value="settingInfoModel.restartReminder === 1"
                        ></el-switch>
                      </div>
                    </div>
                    <div class="push-content">推送内容：文本 + 图片</div>
                    <div class="push-text" style="flex-direction: column; align-items: flex-start;">
                      <div>推送文案：</div>
                      <div
                        class="form-input"
                        v-show="currentComponent === 'edit'"
                      >
                        <el-input
                          type="textarea"
                          v-model="editModel.restartReminderContent"
                          placeholder="请输入"
                          :rows="10"
                        ></el-input>
                      </div>
                      <div
                        class="item-value restart-copywriter"
                        v-show="currentComponent === 'display'"
                      >
                        {{ settingInfoModel.restartReminderContent || "-" }}
                      </div>
                    </div>
                  </div>
                  <!-- <div class="info-item-card">
                    <div class="push-info-item">
                      <div class="switch-item">
                        <span>患者绑定设备信息成功</span>
                        <el-switch
                          v-model="editModel.bindDeviceSuccess"
                        ></el-switch>
                      </div>
                    </div>
                    <div class="push-time">
                      推送时间：高级管理员为用户新关联了设备
                    </div>
                    <div class="push-content">推送内容：{姓名}已绑定</div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="info-section" style="margin-right: 40px">
            <div class="section-header">
              <span class="section-title">推送患者配置</span>
            </div>
            <div class="info-content">
              <div class="info-item-card">
                <div class="push-info-item">
                  <div class="item-label">短信通知：</div>
                  <div class="switch-item">
                    <span>监测设备开启成功</span>
                    <el-switch
                      v-model="editModel.reportSendCopywriter"
                    ></el-switch>
                  </div>
                </div>
                <div class="push-time">推送时间：识别满足即触发</div>
                <div class="push-content">
                  推送内容：您的睡眠设备启动成功并开启监测，请安心开始睡眠监测。
                </div>
              </div>

              <div class="info-item-card">
                <div class="push-info-item">
                  <div class="switch-item">
                    <span>异常设备并取报告</span>
                    <el-switch v-model="editModel.abnormalReason"></el-switch>
                  </div>
                </div>
                <div class="push-time">推送时间：识别满足即触发</div>
                <div class="push-content">
                  关联的短信提醒：温馨提示，您的监测已完成，请及时取设备及报告！
                </div>
              </div>

              <div class="push-info-item">
                <div class="item-label">备注：</div>
                <div class="form-input">
                  <el-input
                    type="textarea"
                    v-model="editModel.remark"
                    placeholder="请输入"
                    :rows="4"
                  ></el-input>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="form-actions" v-if="currentComponent === 'edit'">
          <el-button @click="onCancelClick">取消</el-button>
          <el-button type="primary" @click="onSaveClick">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Card, Switch, Input, Select, Option } from "element-ui";
export default {
  components: {
    ElButton: Button,
    ElCard: Card,
    ElSwitch: Switch,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
  },
  data() {
    return {
      currentComponent: "display", // display or edit
      settingInfoModel: {
        id: 0,
        hospitalId: 0,
        chatRooms: "",
        chatRoomsName: "",
        reportSendType: 0,
        reportSendCopywriter: 0,
        reportCopywriter: "{姓名}{日期} 的报告已发布，请注意查收。",
        bindDeviceSuccess: 0,
        startMonitorSuccess: 0,
        abnormalReason: 0,
        remark: "",
        restartReminder: 0,
        restartReminderContent: "",
        gmtModify: "",
        gmtCreate: "",
      },
      editModel: {
        id: 0,
        hospitalId: 0,
        chatRooms: "",
        reportSendType: false,
        reportSendCopywriter: false,
        reportCopywriter: "{姓名}{日期} 的报告已发布，请注意查收。",
        bindDeviceSuccess: false,
        startMonitorSuccess: false,
        abnormalReason: false,
        remark: "",
        restartReminder: false,
        restartReminderContent: '老师，您好，提醒一下{姓名}{设备号}昨晚监测数据还没收取完成，报告暂时未生成，设备需要您重启一下。重启具体操作步骤如下：',
      },
      chatRoomsList: [],
    };
  },
  computed: {
    hospitalID: function () {
      return this.$store.state.selectedHospital.hospitalid;
    },
    defaultRestartReminderContent: function () {
      return '老师，您好，提醒一下{姓名}{设备号}昨晚监测数据还没收取完成，报告暂时未生成，设备需要您重启一下。重启具体操作步骤如下：';
    },
  },

  watch: {
    hospitalID: function () {
      this.getPushInfo();
      this.getChatRooms();
    },
  },
  created() {
    this.getPushInfo();
    this.getChatRooms();
  },

  methods: {
    onEditClick() {
      this.currentComponent = "edit";
      this.mapSettingInfoToEditModel();
    },

    onCancelClick() {
      this.currentComponent = "display";
    },

    onSaveClick() {
      this.saveInfo();
    },

    mapSettingInfoToEditModel() {
      // 将API数据映射到编辑模型
      this.editModel = {
        id: this.settingInfoModel.id || undefined,
        hospitalId: this.hospitalID,
        chatRooms: this.settingInfoModel.chatRooms || "",
        reportSendType: this.settingInfoModel.reportSendType === 1,
        reportSendCopywriter: this.settingInfoModel.reportSendCopywriter === 1,
        reportCopywriter: this.settingInfoModel.reportCopywriter || "{姓名}{日期} 的报告已发布，请注意查收。",
        bindDeviceSuccess: this.settingInfoModel.bindDeviceSuccess === 1,
        startMonitorSuccess: this.settingInfoModel.startMonitorSuccess === 1,
        abnormalReason: this.settingInfoModel.abnormalReason === 1,
        remark: this.settingInfoModel.remark || "",
        restartReminder: this.settingInfoModel.restartReminder === 1,
        restartReminderContent: this.settingInfoModel.restartReminderContent || this.defaultRestartReminderContent,
      };
    },

    async getPushInfo() {
      try {
        const params = { hospitalId: this.hospitalID };
        const response = await this.$api.getSleepHospitalGewechat(params);
        if (response) {
          this.settingInfoModel = response;
          if (!this.settingInfoModel.restartReminderContent) {
            this.settingInfoModel.restartReminderContent = this.defaultRestartReminderContent;
          }
        } else {
          // 如果没有数据，使用默认值
          this.settingInfoModel = {
            id: 0,
            hospitalId: this.hospitalID,
            chatRooms: "",
            chatRoomsName: "",
            reportSendType: 0,
            reportSendCopywriter: 0,
            reportCopywriter: "",
            bindDeviceSuccess: 0,
            startMonitorSuccess: 0,
            abnormalReason: 0,
            remark: "",
            restartReminder: 0,
            restartReminderContent: "",
            gmtModify: "",
            gmtCreate: "",
          };
        }
      } catch (error) {
        console.error("获取推送配置信息失败", error);
        this.$toast.showRed("获取推送配置信息失败");
      }
    },

    async getChatRooms() {
      try {
        const params = { hospitalId: this.hospitalID };
        const response = await this.$api.geWechatChatRooms(params);
        if (response) {
          this.chatRoomsList = response;
        }
      } catch (error) {
        console.error("获取微信群列表失败", error);
        this.$toast.showRed("获取微信群列表失败");
      }
    },

    async onRefreshClick() {
      try {
        const params = { hospitalId: this.hospitalID };
        const response = await this.$api.chatRoomClearCache(params);
        if (response) {
          this.getChatRooms();
        }
      } catch (error) {
        this.$toast.showRed("清除缓存失败");
      }
    },

    async saveInfo() {
      if (this.editModel.chatRooms === "") {
        this.$toast.showRed("请选择推送对象");
        return;
      }
      try {
        // 将布尔值转换为整数
        const params = {
          id: this.editModel.id,
          hospitalId: this.hospitalID,
          chatRooms: this.editModel.chatRooms,
          reportSendType: this.editModel.reportSendType ? 1 : 0,
          reportSendCopywriter: this.editModel.reportSendCopywriter ? 1 : 0,
          reportCopywriter: this.editModel.reportCopywriter,
          bindDeviceSuccess: this.editModel.bindDeviceSuccess ? 1 : 0,
          startMonitorSuccess: this.editModel.startMonitorSuccess ? 1 : 0,
          abnormalReason: this.editModel.abnormalReason ? 1 : 0,
          remark: this.editModel.remark,
          restartReminder: this.editModel.restartReminder ? 1 : 0,
          restartReminderContent: this.editModel.restartReminderContent,
        };

        let response;
        if (this.settingInfoModel.id) {
          // 如果有ID，使用更新接口
          response = await this.$api.updateSleepHospitalGewechat(params);
        } else {
          // 如果没有ID，使用添加接口
          response = await this.$api.addSleepHospitalGewechat(params);
        }

        this.$toast.showGreen("保存成功");
        this.currentComponent = "display";
        this.getPushInfo(); // 重新获取数据
      } catch (error) {
        console.error("保存推送配置信息失败", error);
        this.$toast.showRed("保存推送配置信息失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.push-configuration {
  background-color: white;
  border-radius: rem(2);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &-container-top {
    width: 100%;
    height: rem(72);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: rem(36);
    box-sizing: border-box;

    &-edit {
      font-size: rem(14);
    }
  }

  &-container {
    flex: 1;
    min-height: 0;
    overflow: auto;
    box-sizing: border-box;
    padding: rem(0) rem(36) rem(50);
  }

  &-bottom {
    width: 100%;
  }
}

.info-section {
  margin-bottom: rem(30);

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: rem(15) 0 0 0;
    margin-bottom: rem(15);

    .section-title {
      font-size: rem(16);
      font-weight: bold;
      color: #333;
    }
  }

  .info-content {
    padding: rem(0) rem(0);
  }
}

.info-item-card {
  border: 1px solid #e8e8e8;
  border-radius: rem(4);
  padding: rem(12);
  margin-bottom: rem(15);
  width: 256px;
}

.push-info-edit {
  width: 100%;
  padding: rem(10) 0;
  display: flex;
  justify-content: space-between;

  .push-info-item {
    flex: 1;
    display: flex;
    margin-bottom: rem(15);
    align-items: center;

    .item-label {
      width: rem(100);
      color: #333;
      font-weight: bold;
      font-size: rem(14);
    }

    .item-value {
      flex: 1;
      color: #333;
      font-size: rem(14);
    }

    &-label {
      font-size: rem(14);
      color: #333;
    }

    .refresh-icon {
      margin-left: 5px;
      font-size: 14px;
      cursor: pointer;
    }

    .form-input {
      flex: 1;

      .el-input {
        width: 100%;
        height: rem(32);
        /deep/.el-input__inner {
          height: rem(32);
        }
      }
      .el-select {
        width: 280px;
      }
    }
  }

  .switch-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: rem(14);
    font-weight: bold;
    color: #333;
  }

  .push-time,
  .push-content,
  .push-text {
    font-size: rem(14);
    color: #333;
    margin: 12px 0;
  }
  .push-text {
    display: flex;
    align-items: center;
  }
}

.form-actions {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: rem(30);
  gap: rem(15);
}

// 全局样式
:deep(.el-input__inner) {
  font-size: rem(14);
}

:deep(.el-switch__label) {
  font-size: rem(14);
}

:deep(.el-button) {
  font-size: rem(14);
}

:deep(.el-textarea__inner) {
  font-size: rem(14);
}

.restart-copywriter {
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
